import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './style.scss';
import Button from "../Button/index.jsx";
import LanguageSwitcher from "../../LanguageSwitcher/index.jsx";

export default function Splash({isNavBar=true}) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  function clickedRegister() {
    navigate('/register');
  }

  function clickedLogin() {
    navigate('/login');
  }
  return (
    <div className='splash__container'>
        <Button onClick={clickedRegister} className={'button__charlie'} >{t('register')}</Button>
        <Button onClick={clickedLogin} className={'button__charlie'}>  {t('login')}</Button>
        {isNavBar && <LanguageSwitcher /> }

    </div>
  );
}
